<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <l-map v-if="loaded" :zoom="zoom" :center="center" ref="map" style="height: 418px">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <l-control class="map-custom-control">
                        <dashboard-filters key="officer" title="Officers" :roles="rolesOptions" :officers="OfficerOptions"
                            @select-officer="selectedOfficer = $event" @select-role="selectedRole = $event"
                            :filters="['role', 'officer']" />
                    </l-control>
                    <l-circle-marker v-for="(officer, index) in formattedOfficers" :key="index" :lat-lng="officer.latlng"
                        :radius="officer.radius" :color="officer.orders_incompleted | formatColor"
                        :fill-color="officer.orders_incompleted | formatColor" @mouseover="showPopup($event.target)"
                        >
                        <l-popup :autoClose="false"
                            >
                            <span class="popup_header">{{ officer.name }}</span><br />
                            <span class="popup_label">Incomplete-Total:</span>{{ officer.orders_incompleted }}<br />
                            <span class="popup_label">Incomplete-Value:</span>{{ officer.total_incomplete_value |
                                formatCurrency
                            }}<br />
                            <span class="popup_label">Completed-Total:</span>{{ officer.orders_completed }}<br />
                            <span class="popup_label">Completed-Value:</span>{{ officer.total_completed_value |
                                formatCurrency
                            }}<br />
                            <a :href="officer.id | formatPath">View Activities</a>
                        </l-popup>
                    </l-circle-marker>
                    <l-geo-json :geojson="geojson"></l-geo-json>
                </l-map>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import graphMixins from '@/mixins/graphMixins'
import DashboardFilters from '@/views/Dashboard/DashboardFilters'
import {
    LMap,
    LTileLayer,
    LCircleMarker,
    LPopup,
    LGeoJson,
    LControl,
} from 'vue2-leaflet'
import L from 'leaflet'
import jamaica_parishes_geojson from '../../exports/geoserver-GetFeature.json'

const defaultLocation = L.latLng(18, -77.2)
const incompleteQry = '/#/admin/activities/?page=1&query=&changed=0&entity=1'

export default {
    name: 'officers-map',
    components: {
        LMap,
        LTileLayer,
        LCircleMarker,
        LPopup,
        LGeoJson,
        LControl,
        DashboardFilters,
    },
    mixins: [graphMixins],
    props: {
        officers: {
            type: Array,
            default: () => [],
        },
        roles: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => defaultLocation,
        },
        loaded: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            geojson: jamaica_parishes_geojson,
            zoom: 8,
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution:
                '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        }
    },
    filters: {
        formatCurrency(val) {
            const currencyFormatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            return currencyFormatter.format(val)
        },
        formatPath(id) {
            return incompleteQry + '&driver_id=' + id
        },
        formatColor(orders_incompleted) {
            if (orders_incompleted > 5) {
                return 'red'
            } else if (orders_incompleted > 0) {
                return 'yellow'
            } else {
                return 'green'
            }
        },
    },
    computed: {
        formattedOfficers() {
            const role_id = this.selectedRole
            const officer_id = this.selectedOfficer
            const officers = this.getOfficers(role_id, officer_id)
            return officers.map(_officer => {
                console.log('_officer.total_value', _officer.total_value)

                _officer.total_incomplete_value =
                    _officer.total_value - _officer.total_completed_value

                _officer.orders_incompleted =
                    _officer.orders_count - _officer.orders_completed
                _officer.radius = 8

                const { latitude, longitude } = this.setCoordinate(_officer)
                _officer.latlng = new L.latLng(
                    parseFloat(latitude),
                    parseFloat(longitude)
                )
                return _officer
            })
        },
        center() {
            const count = this.formattedOfficers.length
            if (count === 0) return defaultLocation
            const s = this.formattedOfficers.reduce(
                (sum, officer) => {
                    const { latitude, longitude } = this.setCoordinate(officer)
                    sum.latitude = sum.latitude + latitude
                    sum.longitude = sum.longitude + longitude
                    return sum
                },
                {
                    latitude: 0,
                    longitude: 0,
                }
            )
            let latitude = 0,
                longitude = 0
            if (count > 0) {
                latitude = s.latitude / count
                longitude = s.longitude / count
            }
            return new L.latLng(latitude, longitude)
        },
    },
    watch: {
        loaded: function (val) {
            if (val) {
                const $this = this
                this.$nextTick(() => {
                    const map = $this.$refs.map.mapObject
                    map.addControl(new L.Control.Fullscreen())
                })
            }
        },
    },


    methods: {
        showPopup(marker) {
            marker.openPopup();
        },
        setCoordinate({ longitude, latitude }) {
            longitude = parseFloat(longitude) || -77.2
            latitude = parseFloat(latitude) || 18
            return { longitude, latitude }
        },

        showAlert() {
            alert('Click!')
        },

        getOfficers(role_id, officer_id) {
            if (!role_id && !officer_id) return this.officers
            else if (officer_id)
                return [this.officers.find(x => x.id === officer_id)]

            const $this = this
            return this.officers.filter(x => $this.isOfficerInRole(x, role_id))
        },
    },
}
</script>

<style>
.autocomplete input {
    border-radius: 0;
}

#map.fullscreen {
    z-index: 9999;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
}

#map {
    height: 418px;
    z-index: 0;
}

.map-custom-control {
    background: #fff;
    padding: 0 0.5em;
    border: 1px solid #aaa;
    border-radius: 0.1em;
}

dl {
    display: grid;
    grid-template-columns: max-content auto;
}

dt {
    grid-column-start: 1;
}

dd {
    grid-column-start: 2;
}

.popup_header {
    text-decoration: underline;
    font-weight: bold;
}

.popup_label {
    font-weight: bold;
}
</style>
